import CloseIcon from "@mui/icons-material/Close";
import { Divider, Grid, Tooltip } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import moment from "moment";
import PropTypes from "prop-types";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import PerfectScrollbar from "react-perfect-scrollbar";
import { useDispatch } from "react-redux";
import "../../../src/components/VisitorActionsComponents/profileCard.css";
import SimpleDialogBox from "../../Pages/Approvals/ImageDialog";
import ViewIcon from "../../Pages/Invitations/ViewIcon";
import ViewNDA from "../../Pages/NDA/ViewNDA";
import CommonUtil from "../../Util/CommonUtils";
import {
  getDlImages,
  getvisitorDetails,
} from "../../slices/Invitations/InvitationsSlice";
import { ViewDeliveryReportsDetails } from "../../slices/Reports/DeliveryReportSlice";
import { getSiteById } from "../../slices/Site/SiteSlice";
import { getAllVisitorDocuments } from "../../slices/VisitorDocuments/VisitorDocumentSlice";
import { ThemeContext } from "../../theme/ThemeContext";
import SimpleDialogDemo from "../Approvals/ImageDailogBox";

const BootstrapDialog = styled(Dialog)(({ theme, darkMode }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
    overflowY: "clip",
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  "& .MuiDialog-paper": {
    overflowY: "visible",
    borderRadius: "20px",
    minWidth: "120vh",
    height: "75%",
    opacity: 1,
    backgroundColor: darkMode ? "#0E2A41" : "#FFFFFF",
  },
  "& .MuiDialogContent-root ": {
    padding: "16px 24px",
    position: "relative",
    bottom: "80px",
  },
}));

const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 0, marginBottom: 1 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

function CheckInProfile(props) {
  const [open, setOpen] = React.useState(false);
  const { darkMode, setDiaLogBoxBlur } = useContext(ThemeContext);
  const [siteName, setSiteName] = useState("");
  const [startDate, setStartDate] = useState("");
  const objeckKeyss = [];
  const [checkIn, setCheckIn] = useState("");
  const [endDate, setEndDate] = useState("");
  const [duration, setDuration] = useState("");
  const [imageArray, setImageArray] = useState([]);
  const rowDataMode = props.rowData.visitMode;
  const dispatch = useDispatch();
  const [Dlmode, setDlMode] = useState(false);
  const [dlFrontImage, setDlFrontImage] = useState("");
  const [dlRearImage, setDlRearImage] = useState("");
  const { t } = useTranslation();
  const companySettings = JSON.parse(localStorage.getItem("companySettings"));

  const [payload, setPayload] = useState({
    livePhoto: props.rowData.livePhoto ? props.rowData.livePhoto : "",
    signature: props.rowData.signature ? props.rowData.signature : "",
  });

  const [CheckInpayload, setCheckInPayload] = useState({
    checkInlivePhotoKey: props.rowData.checkInlivePhotoKey
      ? props.rowData.checkInlivePhotoKey
      : "",
  });
  const [checkInPhotoUrl, setCheckInPhotoUrl] = useState("");

  const [livePhotoUrl, setLivePhotoUrl] = useState("");
  const [signatureUrl, setSignaturUrl] = useState("");

  const handleClickOpenSignature = () => {
    if (!CommonUtil.isEmptyString(props.rowData.signature)) {
      loadSignatureData(props.rowData.signature);
    }
    setOpen(true);
  };

  const [openNDADocument, setOpenNDADocument] = useState(false);
  const [selectedNDADocument, setSelectedNDADocument] = useState("");
  const handleNDADocument = (index) => {
    setSelectedNDADocument(props.rowData.ndaSignedDocuments[index]);
    setOpenNDADocument(!openNDADocument);
  };

  const loadSignatureData = () => {
    if (!CommonUtil.isEmptyString(payload.signature)) {
      let objectKeys = [];
      if (!CommonUtil.isEmptyString(payload.signature)) {
        objectKeys.push(payload.signature);
      }
      const dto = {
        objectKeys,
      };
      dispatch(ViewDeliveryReportsDetails(dto))
        .unwrap()
        .then((data) => {
          if (data.code === "STSI0000") {
            data.data.map((obj) => {
              if (payload.signature === obj.objectKey) {
                setSignaturUrl(obj.preSignedUrl);
              }
            });
          }
        });
    }
  };

  const handleClickOpenLivePhoto = () => {
    if (!CommonUtil.isEmptyString(props.rowData.livePhoto)) {
      loadLivePhotoData(props.rowData.livePhoto);
    }
    setOpen(true);
  };

  const loadLivePhotoData = () => {
    if (!CommonUtil.isEmptyString(payload.livePhoto)) {
      let objectKeys = [];
      if (!CommonUtil.isEmptyString(payload.livePhoto)) {
        objectKeys.push(payload.livePhoto);
      }
      const dto = {
        objectKeys,
      };
      dispatch(ViewDeliveryReportsDetails(dto))
        .unwrap()
        .then((data) => {
          if (data.code === "STSI0000") {
            data.data.map((obj) => {
              if (payload.livePhoto === obj.objectKey) {
                setLivePhotoUrl(obj.preSignedUrl);
                setCheckInPhotoUrl(obj.preSignedUrl);
              }
            });
          }
        });
    }
  };

  const loadDrivingLicense = () => {
    const object = {
      visitorId: props.rowData.visitorId,
      documentId: "DRIVING_LICENSE",
    };

    dispatch(getvisitorDetails(object))
      .unwrap()
      .then((res) => {
        console.log("Visitor details:", res);

        if (!Array.isArray(res) || res.length === 0) {
          console.warn("No visitor details found");
          return;
        }

        const objectKeys = res.flatMap(
          (item) => item.documentImages?.map((image) => image.objectKey) || [],
        );

        if (objectKeys.length === 0) {
          console.warn("No driving license images found");
          return;
        }

        dispatch(getDlImages({ objectKeys }))
          .unwrap()
          .then((imageRes) => {
            console.log("DL Images response:", imageRes);

            if (imageRes?.code !== "STSI0000") {
              console.error("Failed to fetch DL images:", imageRes);
              return;
            }

            // Adjust this according to the actual API response structure.
            const images = imageRes.data;

            if (!Array.isArray(images) || images.length < 2) {
              console.warn("Front and rear DL images are not available");
              return;
            }

            setDlMode(true);
            setDlRearImage(images[0]?.preSignedUrl || "");
            setDlFrontImage(images[1]?.preSignedUrl || "");
          })
          .catch((error) => {
            console.error("Failed to load DL images:", error);
          });
      })
      .catch((error) => {
        console.error("Failed to load visitor details:", error);
      });
  };

  const handleClickOpen = () => {
    loadSiteName(props.rowData.siteId);
    loadCheckInLivePhoto();
    setOpen(true);
    loadDrivingLicense();
  };
  const handleClose = () => {
    setOpen(false);
    setDiaLogBoxBlur(false);
  };

  if (open) {
    setDiaLogBoxBlur(true);
  }

  useEffect(() => {
    setEndDate(
      moment(
        CommonUtil.getLocalDateTimeInYearFormat(props.rowData.scheduledEndDate),
      ).format("DD-MM-YY HH:mm"),
    );
    setStartDate(
      moment(
        CommonUtil.getLocalDateTimeInYearFormat(
          props.rowData.scheduledStartDate,
        ),
      ).format("DD-MM-YY HH:mm"),
    );
    setCheckIn(
      moment(
        CommonUtil.getLocalDateTimeInYearFormat(props.rowData.checkIn),
      ).format("DD-MM-YY HH:mm"),
    );
    setTotalDuration(props.rowData);
  }, []);

  const loadSiteName = (siteId) => {
    dispatch(getSiteById(siteId))
      .unwrap()
      .then((data) => {
        if (data.code === "LMSI6000") {
          setSiteName(data.data.name);
        } else {
          setSiteName("");
        }
      });
  };

  const handleClickOpenVisitorDocuments = () => {
    if (!CommonUtil.isEmptyString(props.rowData)) {
      loadVisitorDocumentObjectKeys(props.rowData);
    }
    setOpen(true);
  };

  const loadVisitorDocumentObjectKeys = () => {
    dispatch(getAllVisitorDocuments(props))
      .unwrap()
      .then((data) => {
        if (data.code === "MSGS4000" && data.data.length > 0) {
          const imageUrls = data.data
            .filter((imageData) => "url" in imageData)
            .map((imageData) => imageData.url);
          setImageArray(imageUrls);
        }
      });
  };

  const setTotalDuration = (params) => {
    let start = moment(params.checkIn);
    let end = moment(params.checkOut);
    let duration = moment.duration(end.diff(start));
    setDuration(
      Math.floor(duration.asHours()) +
        moment.utc(duration.asMilliseconds() + 60000).format(":mm"),
    );
  };

  const loadCheckInLivePhoto = () => {
    if (!CommonUtil.isEmptyString(CheckInpayload.checkInlivePhotoKey)) {
      let objectKeys = [];
      if (!CommonUtil.isEmptyString(CheckInpayload.checkInlivePhotoKey)) {
        objectKeys.push(CheckInpayload.checkInlivePhotoKey);
      }
      const dto = {
        objectKeys,
      };
      dispatch(ViewDeliveryReportsDetails(dto))
        .unwrap()
        .then((data) => {
          if (data.code === "STSI0000") {
            data.data.map((obj) => {
              if (CheckInpayload.checkInlivePhotoKey === obj.objectKey) {
                setCheckInPhotoUrl(obj.preSignedUrl);
              }
            });
          }
        });
    }
  };

  const handleTextOverflow = (text) => {
    if (text && text.length > 45) {
      return text.substring(0, 45) + "...";
    } else {
      return text;
    }
  };

  const [date, setDate] = useState(companySettings.dateFormat);

  return (
    <div>
      <div
        onClick={() => {
          handleClickOpen();
          handleClickOpenLivePhoto();
          handleClickOpenSignature();
          handleClickOpenVisitorDocuments();
        }}
      >
        <ViewIcon darkMode={darkMode} />
      </div>
      <Grid>
        <BootstrapDialog
          aria-labelledby="customized-dialog-title"
          open={open}
          darkMode={darkMode}
          disableBackdropClick
          disableEscapeKeyDown
          BackdropProps={{
            style: {
              backdropFilter: "blur(5px)",
            },
          }}
        >
          <BootstrapDialogTitle onClose={handleClose}>
            <Avatar
              onContextMenu={(e) => e.preventDefault()}
              alt={props.rowData.visitor.firstName}
              src={
                props.rowData.visitor.profilePhotoURL !== undefined
                  ? props.rowData.visitor.profilePhotoURL
                  : null
              }
              sx={{
                width: 150,
                height: 150,
                bottom: "80px",
                margin: "auto",
                border: "solid #FFFF",
                borderWidth: "7px",
              }}
            />
            <Tooltip
              title={
                props.rowData.visitor.lastName === null
                  ? props.rowData.visitor.firstName
                  : props.rowData.visitor.firstName +
                    " " +
                    props.rowData.visitor.lastName
              }
            >
              <div
                className="CssTextProfileViewPageName"
                style={{ color: darkMode ? "#fff" : "#3D4977" }}
              >
                {handleTextOverflow(
                  props.rowData.visitor.lastName === null
                    ? props.rowData.visitor.firstName
                    : props.rowData.visitor.firstName +
                        " " +
                        props.rowData.visitor.lastName,
                )}
              </div>
            </Tooltip>
            <div
              className="CssTextProfileViewPageName"
              style={{ color: darkMode ? "#fff" : "#3D4977" }}
            >
              {props.rowData.visitor.phone}
            </div>
          </BootstrapDialogTitle>

          <DialogContent
            style={{
              marginLeft: "70px",
              height: "400px",
              overflow: "auto",
              overflowX: "hidden",
            }}
          >
            <PerfectScrollbar>
              <Grid
                container
                spacing={12.25}
                className="CssTextProfileViewPageContent"
                marginTop={0.5}
              >
                <Grid
                  container
                  spacing={2}
                  p={1.25}
                  style={{ color: darkMode ? "#fff" : "" }}
                >
                  <Grid item xs={12} sm={3}>
                    {t("COMMON042")}
                  </Grid>
                  <Grid item>:</Grid>
                  <Tooltip title={props.rowData.visitor.email}>
                    <Grid
                      item
                      sx={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      {handleTextOverflow(props.rowData.visitor.email)}
                    </Grid>
                  </Tooltip>
                </Grid>
                <Grid
                  container
                  spacing={2}
                  p={1.25}
                  style={{ color: darkMode ? "#fff" : "" }}
                >
                  <Grid item xs={12} sm={3}>
                    {t("commonsTextFeildHostValue")}
                  </Grid>
                  <Grid item>:</Grid>
                  <Tooltip title={props.rowData.hostName}>
                    <Grid
                      item
                      sx={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      {handleTextOverflow(props.rowData.hostName)}
                    </Grid>
                  </Tooltip>
                </Grid>
                <Grid
                  container
                  spacing={2}
                  p={1.25}
                  style={{ color: darkMode ? "#fff" : "" }}
                >
                  <Grid item xs={12} sm={3}>
                    {t("PURPOSETYPE")}
                  </Grid>
                  <Grid item>:</Grid>
                  <Grid
                    item
                    sx={{
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    {handleTextOverflow(props.rowData.purposeType?.name)}
                  </Grid>
                </Grid>
                <Grid
                  container
                  spacing={2}
                  p={1.25}
                  style={{ color: darkMode ? "#fff" : "" }}
                >
                  <Grid item xs={12} sm={3}>
                    {t("COMMON068")}
                  </Grid>
                  <Grid item>:</Grid>
                  <Grid
                    item
                    sx={{
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    {props.rowData.visitorType?.name}
                  </Grid>
                </Grid>
                <Grid
                  container
                  spacing={2}
                  p={1.25}
                  style={{ color: darkMode ? "#fff" : "" }}
                >
                  <Grid item xs={12} sm={3}>
                    {t("SITE013")}
                  </Grid>
                  <Grid item>:</Grid>
                  <Tooltip title={siteName}>
                    <Grid
                      item
                      sx={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      {handleTextOverflow(siteName)}
                    </Grid>
                  </Tooltip>
                </Grid>
                <Grid
                  container
                  spacing={2}
                  p={1.25}
                  style={{ color: darkMode ? "#fff" : "" }}
                >
                  <Grid item xs={12} sm={3}>
                    {t("VISUPDATE0006")}
                  </Grid>
                  <Grid item>:</Grid>
                  <Tooltip title={props.rowData.visitor.visitorCompanyName}>
                    <Grid
                      item
                      sx={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      {handleTextOverflow(
                        props.rowData.visitor.visitorCompanyName,
                      )}
                    </Grid>
                  </Tooltip>
                </Grid>
                <Grid
                  container
                  spacing={2}
                  p={1.25}
                  style={{ color: darkMode ? "#fff" : "" }}
                >
                  <Grid item xs={12} sm={3}>
                    {t("INVITESTARTDATE")}
                  </Grid>
                  <Grid item>:</Grid>
                  <Grid
                    item
                    sx={{
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    {/* {inviteDate()} */}
                    {date === "MM-dd-yyyy"
                      ? moment(
                          CommonUtil.getLocalDateTimeInYearFormat(
                            props.rowData.scheduledStartDate,
                          ),
                        ).format("MM-DD-YYYY HH:mm")
                      : date === "dd-MM-yyyy"
                      ? moment(
                          CommonUtil.getLocalDateTimeInYearFormat(
                            props.rowData.scheduledStartDate,
                          ),
                        ).format("DD-MM-YYYY HH:mm")
                      : date === "yyyy-MM-dd"
                      ? moment(
                          CommonUtil.getLocalDateTimeInYearFormat(
                            props.rowData.scheduledStartDate,
                          ),
                        ).format("YYYY-MM-DD HH:mm")
                      : ""}
                  </Grid>
                </Grid>
                <Grid
                  container
                  spacing={2}
                  p={1.25}
                  style={{ color: darkMode ? "#fff" : "" }}
                >
                  <Grid item xs={12} sm={3}>
                    {t("INVITENDATE")}
                  </Grid>
                  <Grid item>:</Grid>
                  <Grid
                    item
                    sx={{
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    {/* {inviteEndDate()} */}
                    {date === "MM-dd-yyyy"
                      ? moment(
                          CommonUtil.getLocalDateTimeInYearFormat(
                            props.rowData.scheduledEndDate,
                          ),
                        ).format("MM-DD-YYYY HH:mm")
                      : date === "dd-MM-yyyy"
                      ? moment(
                          CommonUtil.getLocalDateTimeInYearFormat(
                            props.rowData.scheduledEndDate,
                          ),
                        ).format("DD-MM-YYYY HH:mm")
                      : date === "yyyy-MM-dd"
                      ? moment(
                          CommonUtil.getLocalDateTimeInYearFormat(
                            props.rowData.scheduledEndDate,
                          ),
                        ).format("YYYY-MM-DD HH:mm")
                      : ""}
                  </Grid>
                </Grid>

                {props.rowData.status === "CHECKED_OUT" ||
                props.rowData.status === "CHECKED_IN" ? (
                  <Grid
                    container
                    spacing={2}
                    p={1.25}
                    style={{ color: darkMode ? "#fff" : "" }}
                  >
                    <Grid item xs={12} sm={3}>
                      {t("commonsCheckIn")}
                    </Grid>
                    <Grid item>:</Grid>
                    <Grid
                      item
                      sx={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      {props.rowData.checkIn
                        ? moment(
                            CommonUtil.getLocalDateTimeInYearFormat(
                              props.rowData.checkIn,
                            ),
                          ).format(
                            date === "MM-dd-yyyy"
                              ? "MM-DD-YYYY HH:mm"
                              : date === "dd-MM-yyyy"
                              ? "DD-MM-YYYY HH:mm"
                              : "YYYY-MM-DD HH:mm",
                          )
                        : ""}
                    </Grid>
                  </Grid>
                ) : (
                  ""
                )}

                {props.rowData.status === "CHECKED_OUT" ? (
                  <Grid
                    container
                    spacing={2}
                    p={1.25}
                    style={{ color: darkMode ? "#fff" : "" }}
                  >
                    <Grid item xs={12} sm={3}>
                      {t("commonsCheckOut")}
                    </Grid>
                    <Grid item>:</Grid>
                    <Grid
                      item
                      sx={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      {props.rowData.checkOut
                        ? moment(
                            CommonUtil.getLocalDateTimeInYearFormat(
                              props.rowData.checkOut,
                            ),
                          ).format(
                            date === "MM-dd-yyyy"
                              ? "MM-DD-YYYY HH:mm"
                              : date === "dd-MM-yyyy"
                              ? "DD-MM-YYYY HH:mm"
                              : "YYYY-MM-DD HH:mm",
                          )
                        : ""}
                    </Grid>
                  </Grid>
                ) : (
                  ""
                )}

                {props.rowData.status === "CHECKED_OUT" ? (
                  <Grid
                    container
                    spacing={2}
                    p={1.25}
                    style={{ color: darkMode ? "#fff" : "" }}
                  >
                    <Grid item xs={12} sm={3}>
                      {t("TOTAL")}
                    </Grid>
                    <Grid item>:</Grid>
                    <Grid
                      item
                      sx={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      {duration}
                    </Grid>
                  </Grid>
                ) : (
                  ""
                )}

                {process.env.REACT_APP_ENVIRONMENT === "USA" ? (
                  <Grid
                    container
                    spacing={2}
                    p={1.25}
                    style={{ color: darkMode ? "#fff" : "" }}
                  >
                    <Grid item xs={12} sm={3}>
                      {t("COMMON026")}
                    </Grid>
                    <Grid item>:</Grid>
                    <Grid
                      item
                      sx={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      {props.rowData.visitMode === "WALKIN_REGISTARTION"
                        ? t("WALKINREPORTLBL")
                        : props.rowData.visitMode === "INVITATION"
                        ? t("INVITATION001")
                        : props.rowData.visitMode ===
                          "WALKIN_REGISTARTION_KIOSK"
                        ? t("WALKINREPORTLBL1")
                        : props.rowData.visitMode === "SELF_REGISTARTION"
                        ? t("SELFREGISTRATIONLBL")
                        : props.rowData.visitMode === "PRE_REGISTRATION"
                        ? t("PRE_REGISTRATION")
                        : props.rowData.visitMode}
                    </Grid>
                  </Grid>
                ) : (
                  <Grid
                    container
                    spacing={2}
                    p={1.25}
                    style={{ color: darkMode ? "#fff" : "" }}
                  >
                    <Grid item xs={12} sm={3}>
                      {t("COMMON026")}
                    </Grid>
                    <Grid item>:</Grid>
                    <Grid
                      item
                      sx={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      {props.rowData.visitMode === "WALKIN_REGISTARTION"
                        ? t("WALKINREPORTLBL")
                        : props.rowData.visitMode === "INVITATION"
                        ? t("INVITATION001")
                        : props.rowData.visitMode ===
                          "WALKIN_REGISTARTION_KIOSK"
                        ? t("WALKINREPORTLBL1")
                        : props.rowData.visitMode === "SELF_REGISTARTION"
                        ? t("SELFREGISTRATIONLBL")
                        : props.rowData.visitMode === "PRE_REGISTRATION"
                        ? t("PRE_REGISTRATION")
                        : props.rowData.visitMode}
                    </Grid>
                  </Grid>
                )}

                {props.rowData.status === "CHECKED_IN" ||
                props.rowData.status === "CHECKED_OUT" ? (
                  <Grid
                    container
                    spacing={2}
                    p={1.25}
                    style={{ color: darkMode ? "#fff" : "" }}
                  >
                    {props.rowData.status === "CHECKED_OUT" ? (
                      <Grid item xs={12} sm={3}>
                        {t("VISLOGVERIFYMODEOUT")}
                      </Grid>
                    ) : (
                      <Grid item xs={12} sm={3}>
                        {t("VISLOGVERIFYMODEIN")}
                      </Grid>
                    )}
                    <Grid item>:</Grid>
                    {props.rowData.verifyTypeIn === "PASSCODE" ? (
                      <Grid
                        item
                        sx={{
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        {t("PIN")}
                      </Grid>
                    ) : (
                      <Grid
                        item
                        sx={{
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        {t("QRCODE")}
                      </Grid>
                    )}
                  </Grid>
                ) : (
                  ""
                )}

                <Grid
                  container
                  spacing={2}
                  p={1.25}
                  style={{ color: darkMode ? "#fff" : "" }}
                >
                  <Grid item xs={12} sm={3}>
                    {t("COMMON001")}
                  </Grid>
                  <Grid item>:</Grid>
                  <Grid
                    item
                    sx={{
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <span
                      style={{
                        color: "#EDBD37",
                        backgroundColor: "#EDBD3726",
                        opacity: 1,
                      }}
                    >
                      {props.rowData.status === "SCHEDULED" ? "Scheduled" : ""}
                    </span>

                    <span
                      style={{
                        color: "#A6C212",
                        backgroundColor: "#A6C21226",
                        opacity: 1,
                      }}
                    >
                      {props.rowData.status === "CONFIRMED" ? "Confirmed" : ""}
                    </span>

                    <span
                      style={{
                        color: "#E3393C",
                        backgroundColor: "#E3393C26",
                        opacity: 1,
                      }}
                    >
                      {props.rowData.status === "CANCELLED" ? "Cancelled" : ""}
                    </span>

                    <span
                      style={{
                        color: "#E3393C",
                        backgroundColor: "#E3393C26",
                        opacity: 1,
                      }}
                    >
                      {props.rowData.status === "REJECTED" ? "Rejected" : ""}
                    </span>

                    <span
                      style={{
                        color: "#287ADC",
                        backgroundColor: "#287ADC26",
                        opacity: 1,
                      }}
                    >
                      {props.rowData.status === "CHECKED_IN" ? "Check In" : ""}
                    </span>

                    <span
                      style={{
                        color: "#03ACBF",
                        backgroundColor: "#03ACBF26",
                        opacity: 1,
                      }}
                    >
                      {props.rowData.status === "CHECKED_OUT"
                        ? "Check Out"
                        : ""}
                    </span>

                    <span
                      style={{
                        color: "#36C96D",
                        backgroundColor: "#36C96D26",
                        opacity: 1,
                      }}
                    >
                      {props.rowData.status === "APPROVED" ? "Approved" : ""}
                    </span>

                    <span
                      style={{
                        color: "#ED8637",
                        backgroundColor: "#ED863726",
                        opacity: 1,
                      }}
                    >
                      {props.rowData.status === "MISSED" ? "Missed" : ""}
                    </span>

                    <span
                      style={{
                        color: "#D53033",
                        backgroundColor: "#D5303326",
                        opacity: 1,
                      }}
                    >
                      {props.rowData.status === "BLOCKED" ? "Blacklist" : ""}
                    </span>

                    <span
                      style={{
                        color: "#D53033",
                        backgroundColor: "#D5303326",
                        opacity: 1,
                      }}
                    >
                      {props.rowData.status === "INITIATED_FOR_BLOCKED"
                        ? "Blacklist Initiated"
                        : ""}
                    </span>
                    <span
                      style={{
                        color: "#E3393C",
                        backgroundColor: "#E3393C1A",
                        opacity: 1,
                      }}
                    >
                      {props.rowData.status === "TIME_EXPIRED" && t("EXPIRED")}
                    </span>
                    <span
                      style={{
                        color: "#E16B05",
                        backgroundColor: "#E16B0526",
                        opacity: 1,
                      }}
                    >
                      {props.rowData.status === "PENDING_ARRIVAL" &&
                        "Pending Arrival"}
                    </span>
                  </Grid>
                </Grid>

                {props.rowData.visitMode === "WALKIN_REGISTARTION_KIOSK" ? (
                  <Grid
                    container
                    spacing={2}
                    p={1.25}
                    style={{ color: darkMode ? "#fff" : "" }}
                  >
                    <Grid item xs={12} sm={3}>
                      {t("COMMON016")}
                    </Grid>
                    <Grid item>:</Grid>
                    <Tooltip title={props.rowData.remarks}>
                      <Grid
                        item
                        sx={{
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        {handleTextOverflow(props.rowData.remarks)}
                      </Grid>
                    </Tooltip>
                  </Grid>
                ) : (
                  ""
                )}

                {props.rowData.visitMode === "WALKIN_REGISTARTION" ? (
                  <Grid
                    container
                    spacing={2}
                    p={1.25}
                    style={{ color: darkMode ? "#fff" : "" }}
                  >
                    <Grid item xs={12} sm={3}>
                      {t("COMMON016")}
                    </Grid>
                    <Grid item>:</Grid>
                    <Tooltip title={props.rowData.approvalReason}>
                      <Grid
                        item
                        sx={{
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        {handleTextOverflow(props.rowData.approvalReason)}
                      </Grid>
                    </Tooltip>
                  </Grid>
                ) : (
                  ""
                )}

                {props.rowData.visitMode === "INVITATION" ? (
                  <Grid
                    container
                    spacing={2}
                    p={1.25}
                    style={{ color: darkMode ? "#fff" : "" }}
                  >
                    <Grid item xs={12} sm={3}>
                      {t("COMMON016")}
                    </Grid>
                    <Grid item>:</Grid>
                    <Tooltip title={props.rowData.approvalReason}>
                      <Grid
                        item
                        sx={{
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        {handleTextOverflow(props.rowData.approvalReason)}
                      </Grid>
                    </Tooltip>
                  </Grid>
                ) : (
                  ""
                )}

                {props.rowData.visitMode === "SELF_REGISTARTION" ? (
                  <Grid
                    container
                    spacing={2}
                    p={1.25}
                    style={{ color: darkMode ? "#fff" : "" }}
                  >
                    <Grid item xs={12} sm={3}>
                      {t("COMMON016")}
                    </Grid>
                    <Grid item>:</Grid>
                    <Tooltip title={props.rowData.remarks}>
                      <Grid
                        item
                        sx={{
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        {handleTextOverflow(props.rowData.remarks)}
                      </Grid>
                    </Tooltip>
                  </Grid>
                ) : (
                  ""
                )}

                {props.rowData.visitMode === "PRE_REGISTRATION" && (
                  <Grid
                    container
                    spacing={2}
                    p={1.25}
                    style={{ color: darkMode ? "#fff" : "" }}
                  >
                    <Grid item xs={12} sm={3}>
                      {t("COMMON016")}
                    </Grid>
                    <Grid item>:</Grid>
                    <Tooltip title={props.rowData.remarks}>
                      <Grid
                        item
                        sx={{
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        {handleTextOverflow(props.rowData.remarks)}
                      </Grid>
                    </Tooltip>
                  </Grid>
                )}

                {rowDataMode === "WALKIN_REGISTARTION" ||
                rowDataMode === "WALKIN_REGISTARTION_KIOSK" ||
                rowDataMode === "PRE_REGISTRATION" ? (
                  Dlmode && dlFrontImage ? (
                    <Grid
                      container
                      spacing={2}
                      p={1.25}
                      style={{ color: darkMode ? "#fff" : "" }}
                    >
                      <Grid item xs={12} sm={3}>
                        {t("DL_IMAGES")}
                      </Grid>
                      <Grid item xs="auto">
                        :
                      </Grid>
                      <Grid
                        item
                        sx={{
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <SimpleDialogBox
                          button={
                            <Avatar
                              onContextMenu={(e) => e.preventDefault()}
                              style={{
                                cursor: "pointer",
                                width: "95px",
                                height: "50px",
                                borderRadius: "1px",
                              }}
                              alt={payload.signature}
                              src={dlFrontImage}
                            ></Avatar>
                          }
                          child={
                            <Avatar
                              onContextMenu={(e) => e.preventDefault()}
                              style={{
                                width: "455px",
                                height: "300px",
                                border: "12px solid #FFFF",
                                fontSize: "100px",
                                borderRadius: "1px",
                                cursor: "pointer",
                              }}
                              alt={payload.signature}
                              src={dlFrontImage}
                            ></Avatar>
                          }
                        />
                        <Divider
                          orientation="vertical"
                          sx={{
                            marginLeft: "10px",
                            borderColor: darkMode ? "wheat" : "grey",
                          }}
                        />
                        <SimpleDialogBox
                          button={
                            <Avatar
                              onContextMenu={(e) => e.preventDefault()}
                              style={{
                                cursor: "pointer",
                                width: "95px",
                                height: "50px",
                                borderRadius: "1px",
                                left: "10px",
                              }}
                              alt={payload.signature}
                              src={dlRearImage}
                            ></Avatar>
                          }
                          child={
                            <Avatar
                              onContextMenu={(e) => e.preventDefault()}
                              style={{
                                width: "455px",
                                height: "300px",
                                border: "12px solid #FFFF",
                                fontSize: "100px",
                                borderRadius: "1px",
                                cursor: "pointer",
                              }}
                              alt={payload.signature}
                              src={dlRearImage}
                            ></Avatar>
                          }
                        />
                      </Grid>
                    </Grid>
                  ) : (
                    <Grid
                      container
                      spacing={2}
                      p={1.25}
                      style={{ color: darkMode ? "#fff" : "" }}
                    >
                      <Grid item xs={12} sm={3}>
                        {t("DL_IMAGES")}
                      </Grid>
                      <Grid item>:</Grid>
                      <Grid
                        item
                        sx={{
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <div>
                          <SimpleDialogBox
                            button={
                              <Avatar
                                onContextMenu={(e) => e.preventDefault()}
                                style={{
                                  cursor: "pointer",
                                  width: "95px",
                                  height: "50px",
                                  borderRadius: "1px",
                                }}
                                alt={payload.signature}
                                src={dlRearImage}
                              ></Avatar>
                            }
                            child={
                              <Avatar
                                onContextMenu={(e) => e.preventDefault()}
                                style={{
                                  width: "455px",
                                  height: "300px",
                                  border: "12px solid #FFFF",
                                  fontSize: "100px",
                                  borderRadius: "1px",
                                  cursor: "pointer",
                                }}
                                alt={payload.signature}
                                src={dlRearImage}
                              ></Avatar>
                            }
                          />
                        </div>
                      </Grid>
                    </Grid>
                  )
                ) : (
                  ""
                )}

                <Grid
                  container
                  spacing={2}
                  p={1.25}
                  style={{ color: darkMode ? "#fff" : "" }}
                >
                  <Grid item xs={12} sm={3}>
                    {t("Signature")}
                  </Grid>
                  <Grid item>:</Grid>
                  <Grid
                    item
                    sx={{
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <SimpleDialogBox
                      button={
                        <Avatar
                          onContextMenu={(e) => e.preventDefault()}
                          sx={{
                            cursor: "pointer",
                            width: "95px",
                            height: "50px",
                            borderRadius: "1px",
                            "& img": {
                              objectFit: "contain",
                            },
                          }}
                          alt={payload.signature}
                          src={signatureUrl}
                          onClick={handleClickOpenSignature}
                        ></Avatar>
                      }
                      child={
                        <Avatar
                          onContextMenu={(e) => e.preventDefault()}
                          style={{
                            width: "455px",
                            height: "300px",
                            border: "12px solid #FFFF",
                            fontSize: "100px",
                            borderRadius: "1px",
                            cursor: "pointer",
                          }}
                          alt={payload.signature}
                          src={signatureUrl}
                          onClick={handleClickOpenSignature}
                        ></Avatar>
                      }
                    />
                  </Grid>
                </Grid>

                <Grid
                  container
                  spacing={2}
                  p={1.25}
                  style={{ color: darkMode ? "#fff" : "" }}
                >
                  <Grid item xs={12} sm={3}>
                    {t("CHECKINPHOTO")}
                  </Grid>
                  <Grid item>:</Grid>
                  <Grid
                    item
                    sx={{
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <SimpleDialogDemo
                      button={
                        <Avatar
                          onContextMenu={(e) => e.preventDefault()}
                          style={{
                            cursor: "pointer",
                            width: "60px",
                            height: "60px",
                            borderRadius: "50%",
                          }}
                          alt={payload.livePhoto}
                          src={livePhotoUrl}
                          onClick={handleClickOpenLivePhoto}
                        ></Avatar>
                      }
                      child={
                        <Avatar
                          onContextMenu={(e) => e.preventDefault()}
                          style={{
                            width: "300px",
                            height: "300px",
                            cursor: "pointer",
                          }}
                          alt={payload.livePhoto}
                          src={livePhotoUrl}
                          onClick={handleClickOpenLivePhoto}
                        ></Avatar>
                      }
                    />
                  </Grid>
                </Grid>
                {(rowDataMode === "WALKIN_REGISTARTION" ||
                  rowDataMode === "SELF_REGISTARTION" ||
                  rowDataMode === "WALKIN_REGISTARTION_KIOSK" ||
                  rowDataMode === "PRE_REGISTRATION") && (
                  <Grid
                    container
                    spacing={2}
                    p={1.25}
                    style={{ color: darkMode ? "#fff" : "" }}
                  >
                    <Grid item xs={12} sm={3}>
                      {t("CAPTURED_IMAGE")}
                    </Grid>
                    <Grid item>:</Grid>
                    <Grid
                      item
                      xs={6}
                      container
                      direction="row"
                      spacing={1}
                      // marginLeft={-15}
                    >
                      {imageArray.map((imageUrl, index) => (
                        <Grid item key={index}>
                          <SimpleDialogDemo
                            button={
                              <Avatar
                                onContextMenu={(e) => e.preventDefault()}
                                style={{
                                  cursor: "pointer",
                                  width: "60px",
                                  height: "60px",
                                  borderRadius: "50%",
                                  marginRight: "5px", // Adjust margin to control spacing
                                }}
                                alt={`Image ${index + 1}`}
                                src={imageUrl}
                                onClick={handleClickOpenVisitorDocuments}
                              />
                            }
                            child={
                              <Avatar
                                onContextMenu={(e) => e.preventDefault()}
                                style={{
                                  width: "300px",
                                  height: "300px",
                                  cursor: "pointer",
                                }}
                                alt={`Image ${index + 1}`}
                                src={imageUrl}
                                onClick={handleClickOpenVisitorDocuments}
                              />
                            }
                          />
                        </Grid>
                      ))}
                    </Grid>
                  </Grid>
                )}
                {props.rowData.ndaSignatures.length > 0 && (
                  <Grid
                    container
                    spacing={2}
                    p={1.25}
                    style={{ color: darkMode ? "#fff" : "" }}
                  >
                    <Grid item xs={3}>
                      {t("NDA signature")}
                    </Grid>
                    <Grid item>:</Grid>

                    <Grid item xs={12} sm={8} container spacing={1}>
                      {props.rowData.ndaSignedDocuments
                        ?.slice(0, 2)
                        .map((docUrl, index) => {
                          const signatures = Array.isArray(
                            props.rowData.ndaSignatures,
                          )
                            ? props.rowData.ndaSignatures
                            : [props.rowData.ndaSignatures];
                          const signatureUrl = signatures[index] || "";

                          return (
                            <Grid
                              key={index}
                              item
                              onClick={() => handleNDADocument(index)}
                              style={{ cursor: "pointer" }}
                            >
                              <Avatar
                                onContextMenu={(e) => e.preventDefault()}
                                sx={{
                                  width: "95px",
                                  height: "50px",
                                  borderRadius: "1px",
                                  "& img": {
                                    objectFit: "contain",
                                  },
                                  border: "0.2px solid grey",
                                  backgroundColor: darkMode ? "white" : "",
                                }}
                                alt={`Signature ${index + 1}`}
                                src={signatureUrl}
                              />
                            </Grid>
                          );
                        })}
                    </Grid>
                  </Grid>
                )}
              </Grid>
            </PerfectScrollbar>
          </DialogContent>
        </BootstrapDialog>
      </Grid>
      {openNDADocument && (
        <ViewNDA
          open={openNDADocument}
          onClose={() => {
            setOpenNDADocument(!openNDADocument);
          }}
          document={selectedNDADocument}
        />
      )}
    </div>
  );
}

export default CheckInProfile;
